import React from 'react';

export default ({ className, children, fullscreen = false, scale = false, ...restProps }) => {
  const isScale = window.tmConfig.isScale() || scale;
  const cls = [
    'relative',
    'margin-center',
    'main-constants-padding',
    isScale ? 'media-homepage-width' : 'menu-homepage-width-standard',
    fullscreen && 'fullscreen-wrapper',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <section className={cls} {...restProps}>
      {children}
    </section>
  );
};
